<template>
 <div style="display: flex;flex-direction: column;align-items: center;">
    <div style="margin-bottom: 28px;">
        <span style="font-size: 22px;">
            结果公示
        </span>
    </div>
    <el-form :model="vo">
    <div style="width:100%;" class="el-table el-table--fit el-table--border">
        <div class="el-table__body-wrapper">
   		        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
	          <tbody v-for="ko in koList" :key="ko">

                    <tr v-for="k in ko.passenger.itemList" :key="k">
	          		<td ref="tdlbl_中标供应商" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'zbXmbh'" class="field">中标供应商</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw33" colspan="2">

	          				{{ k.supplier }}
	                </td>
	          		<td ref="tdlbl_标段号" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'section'" class="field">标段号</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ k.section }}
	                </td>
	          	</tr>
				  <tr>
	          		<td ref="tdlbl_发布网站" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'webSite'" class="field">发布网站</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
						{{ ko.webSite }}
	                </td>
	          	</tr>
	          	<tr>
	          		<td ref="tdlbl_发布内容" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'zbWay'" class="field">发布内容</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
                       <span v-html="ko.flContent"></span>                </td>
				</tr>
				<tr>
	          		<td ref="tdlbl_实际发布时间" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'zbType'" class="field">实际发布时间</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
                         <span v-if="ko.publicDate">{{ $moment(ko.publicDate).format('YYYY年MM月DD日') }}</span>
                         <span v-else>-</span>
	                </td>
	          	</tr>

                  <tr>
		          	<td ref="tdlbl_公示发布截图" class="el-table__cell tdlbl tdw17">

			  			<span v-field-lbl="''" class="field">公示发布截图</span>
	                </td>
	                <td class="el-table__cell tdcont tdcont" colspan="5">
	                  <Attachment
ref="attachments" :vo="ko" :is-required="0" accept="*.*" empty-message="" :wf-attach-url="'zbgl/zbxmArch'" :limit-count="10" online-editor="" online-file="" :attachments="ko.passenger.attachments"
			  			:attachs-type="'FORMFILE'" :is-drag="0" :auto-upload="0"
/>
	                </td>
	              </tr>
	          </tbody>
	        </table>
        </div>
    </div>
    </el-form>
 </div>
</template>

<script>
export default {
    components: {

    },
    filters: {
        setTimeData(val) {
            if (val) return moment(val).format('YYYY-MM-DD HH:mm')
            return ''
        }
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },
        module: { type: String, default: null }
    },
    data() {
        return {

            koList: []
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {
        this.getdata()
    },
    methods: {
        getdata() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.vo.id },
                url: this.$route.query.wfEngineUrl + '/getJggsfbById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.koList = response.body.listdata
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
// @import '~@/wapp/common/styles/variables.module.scss';
.inner_table_attach /deep/.form-slicer{
    min-height: 1px !important;
}
/deep/.el-form .el-table.el-table--border td{
	text-align: left;
}
</style>
